import { Component } from '@angular/core';
import { App} from 'ionic-angular';
import { AppState } from '../../../../app/app.global';
import { HttpService } from '../../../../providers/service/httpservice';
import { PERSONINFO } from '../../../../providers/config/serviceurl';
import { StorageService } from '../../../../providers/service/storageservice';
import { LoginPage } from '../../../login/login/login';

@Component({
  selector: 'personalinfo-page',
  templateUrl: 'personalInfo.html'
})

export class PersonalInfo {
  person:any={};
  params:any={};
  user:any={};
	constructor(public global: AppState,private httpService:HttpService,public appCtrl: App) {
		this.user = StorageService.getObj('currentUser');
		if(this.user==null||this.user==""||this.user.userId==null||this.user.userId=='undefined'||this.user.userId==''){
			StorageService.remove('currentUser');
      this.appCtrl.getRootNav().push(LoginPage);
		}else{
				this.person = this.user;
			}
	}
}


// WEBPACK FOOTER //
// ./src/pages/application/teaching/personalinfo/personalinfo.ts